$(document).ready(function () {
//Scrolling services
      // using d3 for convenience
  	  var main = document.querySelector("body");
      var scrolly = main.querySelector(".scrolly");
      var imagecontainer = main.querySelector(".image_box");
      var content = imagecontainer.querySelector(".content");
       var heading = imagecontainer.querySelector("h3");
      var steps = scrolly.querySelectorAll(".step");

      // initialize the scrollama
      var scroller = scrollama();

      // scrollama event handlers
      function handleStepEnter(response) {
        // response = { element, direction, index }
        var el = response.element;

        // remove is-active from all steps
        // then add is-active to this step
        steps.forEach(step => step.classList.remove('is-active'));
        el.classList.add('is-active');

        // update graphic based on step
        content.innerText = el.dataset.text;
        heading.innerText = el.dataset.title;
		imagecontainer.style.backgroundImage  = "url(" + el.dataset.image + ")";

      }

      function init() {
        scroller
          .setup({
            step: ".scrolly .step",
            offset: 0.6,
            debug: false
          })
          .onStepEnter(handleStepEnter);

        // setup resize event
        window.addEventListener("resize", scroller.resize);
      }

      // kick things off
      init();
      //in viewport 
	
		//columns
		var $prestep = $('.step[data-step="1"]');
        var $firststep = $('.step[data-step="2"]');
        var $secondstep = $('.step[data-step="3"]');
        var $thirdstep = $('.step[data-step="4"]');
        var $toolbar = $('.toolbar_inner');
        var $imagebox = $('.image_box');
		var $window = $(window);
		
    
    function check_if_in_view() {
		  var window_height = $window.height();
		  var window_top_position = $window.scrollTop();
		  var window_bottom_position = (window_top_position + window_height);
			
			//animations box
			// $.each($prestep, function() {
			// var $element = $(this);
			// var element_height = $element.outerHeight();
			// var element_top_position = $element.offset().top;
			// var element_bottom_position = (element_top_position + element_height);

			
			// if ((element_bottom_position >= window_top_position) &&
			// 	(element_top_position <= window_bottom_position)) {
   //  			  $imagebox.removeClass('slide-down');
  	// 		} else{
   //             $imagebox.addClass('slide-down');
   //          }
		 //  });
            //if toolbar in view
			// $.each($toolbar, function() {
			// var $element = $(this);
			// var element_height = $element.outerHeight();
			// var element_top_position = $element.offset().top;
			// var element_bottom_position = (element_top_position + element_height);

			
			// if ((element_bottom_position >= window_top_position) &&
			// 	(element_top_position <= window_bottom_position)) {
   //  			   $imagebox.removeClass('slide-down');
  	// 		} 
		 //  });
            // if($secondstep.hasClass('is-active')){
            //   $imagebox.addClass('hidden_h3');
            // }
    		if($prestep.hasClass('is-active') || $firststep.hasClass('is-active') || $secondstep.hasClass('is-active') || $thirdstep.hasClass('is-active')){
              $imagebox.addClass('slide-down');
              $imagebox.removeClass('blankpage');
              $('.pre_text').addClass('displayNone');
            }
            
          // if($prestep.hasClass('is-active')){
          //   $imagebox.addClass('blankpage');
          //   $('.pre_text').addClass('displayNone');
          // }else{
          //   $imagebox.removeClass('blankpage');
          // }
		}

		$window.on('scroll resize', check_if_in_view);
		$window.trigger('scroll');
});